import BusinessIcon from "@mui/icons-material/Business"
import CompanyCreate from "./create"
import CompanyEdit from "./edit"
import CompanyTabList from "./list"
import CompanyShow from "./show"
import Schedule from "./schedule.list"
import ScheduleCreate from "./schedule.create"
import ScheduleEdit from "./schedule.edit"
import CompanyAuditHistoryPage from "./audit"

const options = {
    list: CompanyTabList,
    create: CompanyCreate,
    edit: CompanyEdit,
    show: CompanyShow,
    audit: CompanyAuditHistoryPage,
    icon: BusinessIcon,
    schedules: Schedule,
    schedulecreate: ScheduleCreate,
    scheduleedit: ScheduleEdit
    //recordRepresentation: (record: any)=> `${record.name} (${record.role})`,
}

export default options
